export default __webpack_public_path__ + "static/media/footerLogo.56360da2.png";